export const PAGE_NOT_FOUND_NAME = '404 (•́へ•́╬)';

export const LAYOUT = () => import('@/layout/index.vue');

export const REDIRECT_NAME = 'Redirect';

